import { useCallback, useEffect } from "react";

import { JobDetailsSkeleton } from "components/job/JobDetailsSkeleton";
import { Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store";
import { setPage, setSelectedJob } from "store/root.store";
import {
  getComments,
  getFiles,
  getHistoryJob,
  getNotes,
  getVisits,
  selectJobLoaded,
  setHistorySelectedJob,
} from "store/slices/history.store";
import { addSnackbarMessage } from "store/slices/snackbar.store";
import { isFlagEnabled } from "store/slices/user.store";

interface JobProviderProps {
  jobId: string | undefined;
}

export default function HistoryJobProvider({ jobId }: JobProviderProps) {
  const dispatch = useAppDispatch();
  const jobLoaded = useAppSelector(selectJobLoaded);
  const commentsEnabled = useAppSelector((s) => isFlagEnabled(s, "Comments"));

  const initializeJob = useCallback(async () => {
    await dispatch(getHistoryJob()).catch(() => {
      dispatch(addSnackbarMessage({ key: "GetJob-fail" }));
    });
    dispatch(getFiles());
    dispatch(getNotes());
    dispatch(getVisits()).catch(() => {
      dispatch(addSnackbarMessage({ key: "GetJobVisits-fail" }));
    });
    if (commentsEnabled) dispatch(getComments());
  }, [commentsEnabled, dispatch]);

  useEffect(() => {
    if (!jobId) return;
    dispatch(setPage({ page: "history" }));
    dispatch(setSelectedJob({ jobId }));
    dispatch(setHistorySelectedJob({ jobId }));
    initializeJob();
  }, [dispatch, initializeJob, jobId]);

  if (!jobLoaded) {
    return <JobDetailsSkeleton />;
  }

  return <Outlet />;
}
